const state = {
  loading: true,
}

const getters = {
  getLoading: (state) => state.loading,
}

const actions = {
  load: ({ commit }) => commit('setLoading', true),
  unload: ({ commit }) => commit('setLoading', false),
}

const mutations = {
  setLoading: (state, value) => state.loading = value,
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}